import { useCallback } from 'react';
import { useIsAuthenticated } from './useAuth';

/**
 * Hook para verificar permissões do usuário logado.
 * ADMIN sempre tem todas as permissões.
 */
export const usePermissoes = () => {
  const { user } = useIsAuthenticated();

  const temPermissao = useCallback((permissao: string): boolean => {
    if (!user) return false;
    if (user.perfil === 'ADMIN') return true;
    return user.permissoes?.includes(permissao) ?? false;
  }, [user]);

  const temAlgumaPermissao = useCallback((permissoes: string[]): boolean => {
    if (!user) return false;
    if (user.perfil === 'ADMIN') return true;
    return permissoes.some(p => user.permissoes?.includes(p));
  }, [user]);

  const isAdmin = user?.perfil === 'ADMIN';

  return { temPermissao, temAlgumaPermissao, isAdmin, permissoes: user?.permissoes ?? [] };
};
